/**
 * 약관 관련 상수
 */

export const TERMS = {
	PRIVACY: {
		title: "개인정보 수집 및 이용 동의",
		content: `<!DOCTYPE html>
<!DOCTYPE html>
<html>
<head>
  	<meta charset="utf-8">
  	<meta name="viewport" content="initial-scale=1, width=device-width">
  	
  	<link rel="stylesheet"  href="./index.css" />
  	<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=[object Object]&display=swap" />
  	
  	
  	<style>
	
	.frame-parent {
  	width: 100%;
  	position: relative;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 30px;
  	text-align: left;
  	font-size: 16px;
  	color: #212121;
  	font-family: Pretendard;
}
.parent {
  	align-self: stretch;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 23px;
}
.b {
  	align-self: stretch;
  	position: relative;
  	font-size: 20px;
  	line-height: 30px;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
}
.group {
  	align-self: stretch;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 20px;
}
.div {
  	align-self: stretch;
  	position: relative;
  	line-height: 24px;
}
.ol {
  	margin: 0;
  	font-family: inherit;
  	font-size: inherit;
  	padding-left: 21px;
}
.parent4 {
  	align-self: stretch;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 23px;
  	font-size: 28px;
}
.b7 {
  	align-self: stretch;
  	position: relative;
  	line-height: 42px;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
}
.parent5 {
  	align-self: stretch;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 20px;
  	font-size: 16px;
}


	</style>
</head>
<body>
  	
  	<div class="frame-parent">
    		<div class="parent">
      			<b class="b">제 1장 총칙</b>
      			<div class="group">
        				<b class="div">제 1조(목적)</b>
        				<div class="div">판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다. 판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</div>
      			</div>
      			<div class="group">
        				<b class="div">제 2조</b>
        				<div class="div">판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다. 판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
      			</div>
    		</div>
    		<div class="parent">
      			<b class="b">제 20장 총칙</b>
      			<div class="group">
        				<b class="div">제 1조(목적)</b>
        				<div class="div">판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다. 판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</div>
      			</div>
      			<div class="group">
        				<b class="div">제 2조</b>
        				<div class="div">판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다. 판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>판매자의 귀책(폐업, 품절 등)으로 인하여 서비스 제공이 불가한 경우에는 전액 환불 가능합니다.</li>
          					</ol>
        				</div>
      			</div>
    		</div>
    		<div class="parent4">
      			<b class="b7">부칙</b>
      			<div class="parent5">
        				<div class="div">
          					<ol class="ol">
            						<li>공지일자 : 2024년 11월 13일</li>
          					</ol>
        				</div>
        				<div class="div">
          					<ol class="ol">
            						<li>공지일자 : 2024년 11월 13일</li>
          					</ol>
        				</div>
      			</div>
    		</div>
  	</div>
  	
  	
  	
  	
</body>
</html>`
	},
	THIRD_PARTY: {
		title: "개인정보 제 3자 정보 제공 동의",
		content: `<!-- 여기에 제 3자 정보 제공 동의 HTML 추가 -->`
	},
	SERVICE: {
		title: "결제대행 서비스 이용약관 동의",
		content: `<!-- 여기에 서비스 이용약관 HTML 추가 -->`
	},
	REFUND_GUIDE: {
		title: "환불 가이드",
		content: `<!DOCTYPE html>
<html>
<head>
  	<meta charset="utf-8">
  	<meta name="viewport" content="initial-scale=1, width=device-width">
  	
  	<link rel="stylesheet"  href="./index.css" />
  	<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=[object Object]&display=swap" />
  	
  	<style>
	.frame-parent {
  	width: 100%;
  	position: relative;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 30px;
  	text-align: left;
  	font-size: 16px;
  	color: #212121;
  	font-family: Pretendard;
}
.parent {
  	align-self: stretch;
  	height: 246px;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	gap: 20px;
}
.b {
  	align-self: stretch;
  	position: relative;
  	font-size: 20px;
  	line-height: 30px;
  	overflow: hidden;
  	text-overflow: ellipsis;
  	white-space: nowrap;
}
.ol {
  	margin: 0;
  	font-family: inherit;
  	font-size: inherit;
  	padding-left: 27px;
}
.wrapper {
  	align-self: stretch;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
}
.div {
  	align-self: stretch;
  	position: relative;
  	line-height: 24px;
}
.frame-wrapper {
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
}
.icon-check-parent {
  	width: 320px;
  	display: flex;
  	align-items: flex-start;
  	justify-content: space-between;
  	gap: 2px;
}
.icon-check {
  	height: 24px;
  	width: 24px;
  	position: relative;
}
.pg {
  	width: 294px;
  	position: relative;
  	line-height: 24px;
  	display: inline-block;
  	flex-shrink: 0;
}
.frame-container {
  	align-self: stretch;
  	height: 48px;
  	position: relative;
}
.icon-check-group {
  	position: absolute;
  	top: 0px;
  	left: 0px;
  	width: 320px;
  	display: flex;
  	align-items: flex-start;
  	justify-content: space-between;
  	gap: 2px;
}
.frame-div {
  	width: 1200px;
  	height: 40px;
  	display: flex;
  	align-items: center;
  	flex-shrink: 0;
}
.frame-parent2 {
  	display: flex;
  	align-items: center;
}
.frame-wrapper2 {
  	width: 200px;
  	background-color: #e0e0e0;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	overflow: hidden;
  	flex-shrink: 0;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.container {
  	align-self: stretch;
  	height: 24px;
  	position: relative;
  	overflow: hidden;
  	flex-shrink: 0;
}
.frame-wrapper3 {
  	width: 300px;
  	background-color: #e0e0e0;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	overflow: hidden;
  	flex-shrink: 0;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.b3 {
  	position: absolute;
  	top: calc(50% - 12px);
  	left: 0px;
  	line-height: 24px;
  	display: inline-block;
  	width: 280px;
}
.frame-wrapper5 {
  	width: 400px;
  	background-color: #e0e0e0;
  	border-top: 1px solid #212121;
  	border-right: 1px solid #212121;
  	border-bottom: 1px solid #212121;
  	box-sizing: border-box;
  	overflow: hidden;
  	flex-shrink: 0;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.b5 {
  	position: absolute;
  	top: calc(50% - 12px);
  	left: 0px;
  	line-height: 24px;
  	display: inline-block;
  	width: 380px;
}
.frame-parent3 {
  	width: 1200px;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	flex-shrink: 0;
}
.frame-parent4 {
  	align-self: stretch;
  	height: 88px;
  	position: relative;
}
.frame-wrapper6 {
  	position: absolute;
  	top: 0px;
  	left: 0px;
  	background-color: #fff;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	width: 200px;
  	height: 88px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.android {
  	position: absolute;
  	top: calc(50% - 12px);
  	left: 0px;
  	line-height: 24px;
  	display: inline-block;
  	width: 180px;
}
.wrapper4 {
  	position: absolute;
  	top: 0px;
  	left: 200px;
  	background-color: #fff;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	width: 300px;
  	overflow: hidden;
  	display: flex;
  	align-items: center;
  	justify-content: center;
  	padding: 8px 10px;
}
.div2 {
  	width: 260px;
  	position: relative;
  	line-height: 24px;
  	display: inline-block;
  	flex-shrink: 0;
}
.ul {
  	margin: 0;
  	font-family: inherit;
  	font-size: inherit;
  	padding-left: 21px;
}
.li {
  	margin-bottom: 0px;
}
.frame-wrapper7 {
  	position: absolute;
  	top: 0px;
  	left: 500px;
  	background-color: #fff;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	width: 300px;
  	height: 88px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.frame-wrapper8 {
  	position: absolute;
  	top: 0px;
  	left: 800px;
  	background-color: #fff;
  	border-top: 1px solid #212121;
  	border-right: 1px solid #212121;
  	border-bottom: 1px solid #212121;
  	box-sizing: border-box;
  	width: 400px;
  	height: 88px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.frame-parent6 {
  	align-self: stretch;
  	height: 40px;
  	position: relative;
}
.frame-wrapper12 {
  	position: absolute;
  	top: 0px;
  	left: 0px;
  	background-color: #fff;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	width: 200px;
  	height: 40px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.frame-wrapper13 {
  	position: absolute;
  	top: 0px;
  	left: 500px;
  	background-color: #fff;
  	border: 1px solid #212121;
  	box-sizing: border-box;
  	width: 300px;
  	height: 40px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}
.frame-wrapper14 {
  	position: absolute;
  	top: 0px;
  	left: 800px;
  	background-color: #fff;
  	border-top: 1px solid #212121;
  	border-right: 1px solid #212121;
  	border-bottom: 1px solid #212121;
  	box-sizing: border-box;
  	width: 400px;
  	height: 40px;
  	overflow: hidden;
  	display: flex;
  	flex-direction: column;
  	align-items: flex-start;
  	padding: 8px 10px;
}


	</style>
  	
</head>
<body>
  	
  	<div class="frame-parent">
    		<div class="parent">
      			<b class="b">
        				<ol class="ol">
          					<li>부가서비스 환불 정책</li>
        				</ol>
      			</b>
      			<div class="wrapper">
        				<div class="div">이노코드의 부가서비스는 서비스별로 환불 정책이 다릅니다. 아래 내용을 통해 확인해 주세요.</div>
      			</div>
      			<div class="frame-wrapper">
        				<div class="icon-check-parent">
          					<img class="icon-check" alt="">
          					
          					<div class="pg">PG 정책에 따라 결제일 기준 1년이 지난 건은 환불되지 않습니다.</div>
        				</div>
      			</div>
      			<div class="frame-container">
        				<div class="icon-check-group">
          					<img class="icon-check" alt="">
          					
          					<div class="pg">PG 정책에 따라 결제일 기준 1년이 지난 건은 환불되지 않습니다.</div>
        				</div>
      			</div>
    		</div>
    		<div class="wrapper">
      			<div class="frame-div">
        				<div class="frame-parent2">
          					<div class="frame-wrapper2">
            						<div class="container">
              							<b class="android">서비스</b>
            						</div>
          					</div>
          					<div class="frame-wrapper3">
            						<div class="container">
              							<b class="b3">100% 환불</b>
            						</div>
          					</div>
          					<div class="frame-wrapper3">
            						<div class="container">
              							<b class="b3">수수료 차감 후 환불</b>
            						</div>
          					</div>
          					<div class="frame-wrapper5">
            						<div class="container">
              							<b class="b5">환불 불가</b>
            						</div>
          					</div>
        				</div>
      			</div>
      			<div class="frame-parent3">
        				<div class="frame-parent4">
          					<div class="frame-wrapper6">
            						<div class="container">
              							<div class="android">앱 제작(Android)</div>
            						</div>
          					</div>
          					<div class="wrapper4">
            						<div class="div2">
              							<ul class="ul">
                								<li class="li">제작 미완료 : 결제일로부터 14일 이내</li>
                								<li>이노코드 귀책사유로 스토어 등록 실패</li>
              							</ul>
            						</div>
          					</div>
          					<div class="frame-wrapper7">
            						<div class="container">
              							<div class="b3">수수료 차감 후 환불</div>
            						</div>
          					</div>
          					<div class="frame-wrapper8">
            						<div class="container">
              							<div class="b5">환불 불가</div>
            						</div>
          					</div>
        				</div>
        				<div class="frame-parent4">
          					<div class="frame-wrapper6">
            						<div class="container">
              							<div class="android">앱 제작(iOS)</div>
            						</div>
          					</div>
          					<div class="wrapper4">
            						<div class="div2">
              							<ul class="ul">
                								<li class="li">제작 미완료 : 결제일로부터 14일 이내</li>
                								<li>이노코드 귀책사유로 스토어 등록 실패</li>
              							</ul>
            						</div>
          					</div>
          					<div class="frame-wrapper7">
            						<div class="container">
              							<div class="b3">수수료 차감 후 환불</div>
            						</div>
          					</div>
          					<div class="frame-wrapper8">
            						<div class="container">
              							<div class="b5">환불 불가</div>
            						</div>
          					</div>
        				</div>
        				<div class="frame-parent6">
          					<div class="frame-wrapper12">
            						<div class="container">
              							<div class="android">SMS</div>
            						</div>
          					</div>
          					<div class="wrapper4">
            						<div class="div2">
              							<ul class="ul">
                								<li>결제일로부터 7일 이내 요청</li>
              							</ul>
            						</div>
          					</div>
          					<div class="frame-wrapper13">
            						<div class="container">
              							<div class="b3">수수료 차감 후 환불</div>
            						</div>
          					</div>
          					<div class="frame-wrapper14">
            						<div class="container">
              							<div class="b5">환불 불가</div>
            						</div>
          					</div>
        				</div>
        				<div class="frame-parent6">
          					<div class="frame-wrapper12">
            						<div class="container">
              							<div class="android">SSL 인증서</div>
            						</div>
          					</div>
          					<div class="wrapper4">
            						<div class="div2">
              							<ul class="ul">
                								<li>결제일로부터 7일 이내 요청</li>
              							</ul>
            						</div>
          					</div>
          					<div class="frame-wrapper13">
            						<div class="container">
              							<div class="b3">-</div>
            						</div>
          					</div>
          					<div class="frame-wrapper14">
            						<div class="container">
              							<div class="b5">7일 이후 요청시</div>
            						</div>
          					</div>
        				</div>
      			</div>
    		</div>
  	</div>
  	
  	
  	
  	
</body>
</html>`
	}
} as const;

export type TermType = keyof typeof TERMS;
